<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat v-if="dialog">
      <v-card-title>
        Shareable Link
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        Here is a direct link to your meeting space
      </v-card-subtitle>
      <v-card-text class="pt-0">
        <v-row>
          <v-col cols="auto">
            <v-icon color="performance" x-large>today</v-icon>
          </v-col>
          <v-col>
            Add this link into your calendar event, so you or any other
            participant can easily find the meeting
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <v-icon color="performance" x-large>reply_all</v-icon>
          </v-col>
          <v-col>
            Use this link in any communication tool, so you can quickly get
            participants to your meeting space
          </v-col>
        </v-row>
        <v-row class="background rounded-lg">
          <v-col cols="12">
            <copy-text-field :link="link"></copy-text-field>
          </v-col>
          <v-col cols="12">
            <v-icon class="mr-2" color="primary">info</v-icon>
            Only
            <span
              class="text-decoration-underline cursor-pointer"
              @click="$emit('show-invite')"
              >added participants</span
            >
            can view this meeting
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import CopyTextField from "@/components/common/CopyTextField";
export default {
  name: "ShareCheckInDialog",
  components: { CopyTextField },
  props: {},
  data: () => ({
    dialog: false,
    checkin: {}
  }),
  computed: {
    link() {
      return window.location.href.replace("/start", "");
    },
    ...mapGetters({
      search_users: "user/search_users",
      profile: "profile/profile"
    })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    showDialog(checkin) {
      this.dialog = true;
      this.checkin = checkin;
    }
  }
};
</script>
